import { NgModule } from '@angular/core';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { FormsModule } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';
import { RouterModule } from '@angular/router';
import { AppComponent } from './app.component';
import { HomeComponent } from './home/home.component';
import { NavMenuComponent } from './nav-menu/nav-menu.component';
import { SharedModule } from './shared/shared.module';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { PaymentRequestComponent } from './payment-request/payment-request.component';
import { ReactiveFormsModule } from '@angular/forms'; // Import the necessary modules;
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { AppRoutingModule } from './app-routing.module';
import { CommonService } from './shared/services/common.service';
import { APP_INITIALIZER } from '@angular/core';
import { ExpectFundComponent } from './expect-fund/expect-fund.component';
import { PaymentRequestApprovalComponent } from './payment-request-approval/payment-request-approval.component';
import { ViewPaymentRequestComponent } from './view-payment-request/view-payment-request.component';
import { ViewExpectFundComponent } from './view-expect-fund/view-expect-fund.component';
import { ConfirmationDialogComponent } from './confirmation-dialog/confirmation-dialog.component';
import { DecimalPipe } from '@angular/common';
import { DateAdapter, MAT_DATE_FORMATS } from '@angular/material/core';
import { CustomDateAdapter } from './shared/adapter/CustomDataAdapter';
import { CustomDateDirectiveDirective } from './custom-date-directive.directive';
import { InvalidJurisdictionComponent } from './invalid-jurisdiction/invalid-jurisdiction.component';
import { ManageRolesComponent } from './manage-roles/manage-roles.component';
import { NoAccessToViewComponent } from './no-access-to-view/no-access-to-view.component';
import { TransferFundsComponent } from './transfer-funds/transfer-funds.component';
import { ViewTransferFundRequestComponent } from './view-transfer-fund-request/view-transfer-fund-request.component';
import { AuditLogComponent } from './audit-log/audit-log.component';
import { DownloadStatusComponent } from './shared/download-status/download-status.component';
import { GridLoadErrorComponent } from './shared/grid-load-error/grid-load-error.component';
import { ViewAuditComponent } from './view-audit/view-audit.component';
import { AttachmentListComponent } from './attachment-list/attachment-list.component';
import { SnackbarComponent } from './snackbar/snackbar.component';
import { JournalRequestComponent } from './journal-request/journal-request.component';
import { ViewJournalRequestComponent } from './view-journal-request/view-journal-request.component';
import { ManageSupportedJurisdictionComponent } from './manage-supported-jurisdiction/manage-supported-jurisdiction.component';
import { AddEditJurisdictionComponent } from './manage-supported-jurisdiction/add-edit-jurisdiction/add-edit-jurisdiction.component';
import { UserRequestsComponent } from './user/user-requests/user-requests.component';
import { UserJournalHistoryComponent } from './user/user-journal-history/user-journal-history.component';
import { UserPaymentHistoryComponent } from './user/user-payment-history/user-payment-history.component';
import { UserExpectHistoryComponent } from './user/user-expect-history/user-expect-history.component';
import { UserTransferHistoryComponent } from './user/user-transfer-history/user-transfer-history.component';
import { CompletedRequestsComponent } from './completed/completed-requests/completed-requests.component';
import { ReturnReasonDialogComponent } from './return-reason-dialog/return-reason-dialog.component';
import { ViewUserPaymentComponent } from './view-user-payment/view-user-payment.component';
import { ViewUserExpectComponent } from './view-user-expect/view-user-expect.component';
import { ViewUserTransferComponent } from './view-user-transfer/view-user-transfer.component';
import { ViewUserJournalComponent } from './view-user-journal/view-user-journal.component';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MAT_FORM_FIELD_DEFAULT_OPTIONS } from '@angular/material/form-field';
import { DisbursementComponent } from './disbursement/disbursement.component';
import { GridModule } from '@syncfusion/ej2-angular-grids';
import { DropDownListModule } from '@syncfusion/ej2-angular-dropdowns';
import { ClipboardModule } from '@angular/cdk/clipboard';
import { CurrencyInputDirective } from './shared/directives/currency-input.directive';
import { DraftActionsComponent } from './shared/draft-editor/draft-actions.component';
import { DraftDocumentsComponent } from './shared/draft-editor/draft-documents.component';
import { AuthInterceptor } from './shared/interceptor/auth-interceptor';
import { TokenInterceptor } from './shared/services/token-interceptor';

@NgModule({
    declarations: [
        AppComponent,
        NavMenuComponent,
        HomeComponent,
        PaymentRequestComponent,
        ExpectFundComponent,
        JournalRequestComponent,
        PaymentRequestApprovalComponent,
        ViewPaymentRequestComponent,
        ViewExpectFundComponent,
        ViewTransferFundRequestComponent,
        ViewJournalRequestComponent,
        ConfirmationDialogComponent,
        CustomDateDirectiveDirective,
        AuditLogComponent,
        InvalidJurisdictionComponent,
        ConfirmationDialogComponent,
        ManageRolesComponent,
        NoAccessToViewComponent,
        TransferFundsComponent,
        ViewTransferFundRequestComponent,
        InvalidJurisdictionComponent,
        ViewAuditComponent,
        AttachmentListComponent,
        SnackbarComponent,
        ManageSupportedJurisdictionComponent,
        AddEditJurisdictionComponent,
        UserRequestsComponent,
        UserJournalHistoryComponent,
        UserPaymentHistoryComponent,
        UserExpectHistoryComponent,
        UserTransferHistoryComponent,
        ReturnReasonDialogComponent,
        ViewUserPaymentComponent,
        ViewUserExpectComponent,
        ViewUserTransferComponent,
        ViewUserJournalComponent,
        CompletedRequestsComponent,
        DisbursementComponent
    ],
    imports: [
        BrowserAnimationsModule,
        BrowserModule.withServerTransition({ appId: 'ng-cli-universal' }),
        HttpClientModule,
        AppRoutingModule,
        FormsModule,
        SharedModule,
        DownloadStatusComponent,
        GridLoadErrorComponent,
        GridModule,
        DropDownListModule,
        ClipboardModule,
        CurrencyInputDirective,
        DraftActionsComponent,
        DraftDocumentsComponent
    ],
    providers: [
        {
            provide: HTTP_INTERCEPTORS,
            useClass: TokenInterceptor,
            multi: true,
        },
        {
            provide: HTTP_INTERCEPTORS,
            useClass: AuthInterceptor,
            multi: true
        },
        {
            provide: APP_INITIALIZER,
            multi: true,
            deps: [CommonService],
            useFactory: (commonService: CommonService) => {
                return async () => {
                    //Make sure to return a promise!
                    return await commonService.loadAppConfig();
                };
            }
        },
        {
            provide: DateAdapter,
            useClass: CustomDateAdapter,
        },
        
        DecimalPipe,
        { provide: MAT_FORM_FIELD_DEFAULT_OPTIONS, useValue: { appearance: 'outline' } }
    ],
    bootstrap: [AppComponent]
})
export class AppModule { }
